declare namespace $ {

	export class $bog_builderui_chart extends $mol_chart {
	}
	
}

//# sourceMappingURL=chart.view.tree.d.ts.map